import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthUserContext } from './views/session/context'; // Adjust path as needed

const RequireAuth = ({ children }) => {
  const { authUser, loading } = useContext(AuthUserContext);
  const location = useLocation();
  const isDev = import.meta.env.DEV;

  // Show a loader while checking the user's authentication status
  if (loading) {
    if (isDev) {
      console.debug('[RequireAuth] loading auth state', { path: location.pathname, search: location.search });
    }
    return <div>Loading...</div>; // Replace with a spinner or loading component
  }

  // Redirect to login if the user is not authenticated
  if (!authUser || !authUser.uid) {
    if (isDev) {
      console.warn('[RequireAuth] redirecting to /login', {
        path: location.pathname,
        search: location.search,
        hasAuthUser: Boolean(authUser),
        uid: authUser?.uid || null,
      });
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (isDev) {
    console.debug('[RequireAuth] access granted', { path: location.pathname, uid: authUser.uid });
  }
  // If authenticated, render the protected content
  return children;
};

export default RequireAuth;
